import moment from 'moment';

export class SharprEventTrackerService {
	constructor(Api, Identity) {
		'ngInject';
		this.Api = Api;
		this.Identity = Identity;
		this.pageName = 'Insights';
	}

	isScreenPortrait() {
		return /portrait/.test(screen.msOrientation || screen.mozOrientation || (screen.orientation || {}).type);
	}

	setPageName(pageName) {
		this.pageName = pageName;
	}

	/**
	 * Send event to Sharpr API.
	 * Changes to this function should be mirrored in the `save()` method inside:
	 * - a-react-app/src/libs/metricEvent/metricEvents.js
	 * @param {String} event  The type of event
	 * @param {Object} values  Values specific to this type of event
	 * @param {String} [referrer]  The referring page or window.location.href
	 * @return {Promise}
	 */
	track(event, values = {}, referrer = null) {
		const today = new Date().toDateString();

		const user = this.Identity.user();
		const client = this.Identity.currentClient();
		const viewport = {
			orientation: this.isScreenPortrait() ? 'portrait' : 'landscape',
			screen_width: screen.width,
			screen_height: screen.height,
			viewport_width: window.innerWidth,
			viewport_height: window.innerHeight,
		};
		const options = {
			avoidLoadingBar: true,
		};
		let userId;
		if (user && user.id) {
			userId = user.id;
			this.refreshVisitsMetric({ userId, today });
		} else {
			userId = null;
			options.Authorization = 'Public';
			this.refreshVisitsMetric({ userId: 'guest', today });
		}
		if (typeof referrer != 'string') {
			referrer = window.location.href;
		}
		this.Api.post(
			'/metrics/events',
			{
				event_code: event,
				user_id: userId,
				user_day: moment().format('YYYY-MM-DD'),
				user_tz_offset: new Date().getTimezoneOffset(),
				client_id: client ? client.id : null,
				device_pixel_ratio: window.devicePixelRatio,
				referrer: referrer.slice(0, 2000),
				page_name: this.pageName,
				viewport,
				values,
			},
			options
		);
	}

	/**
	 * Records a site visit metric if the user has none for the day.
	 * Changes to this function should be mirrored inside:
	 * - a-react-app/src/libs/metricEvent/metricEvents.js
	 */
	refreshVisitsMetric({ userId, today }) {
		const activityTracker = JSON.parse(localStorage.getItem('activityTracker') || '{}');
		const lastActivityDate = activityTracker[userId];

		if (lastActivityDate !== today) {
			localStorage.setItem('activityTracker', JSON.stringify({ ...activityTracker, [userId]: today }));
			this.track('site_visits');
		}
	}
}
